import { ActionType, IAssetModel } from "@xala/common-services";
import { Button, Col, Form, Icon, IFormValues, Link, Row } from "@xala/common-ui";
import { ROUTES } from "../../../constants/routes";
import { FormInstance } from "antd/lib/form";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { SelectAssetsModal } from "../../SelectAssetsModal";

interface IActionTypeMediaProps {
  readonly actionType: ActionType | undefined;
  readonly form: FormInstance<IFormValues>;
}

function ActionTypeMedia({
  actionType,
  form,
}: Readonly<IActionTypeMediaProps>) {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  if (actionType !== ActionType.OpenMedia) {
    return null;
  }

  const onSelect = (row: IAssetModel) => {
    form.setFieldsValue({
      AssetId: row.Id,
      AssetTitle: row.Title,
    });
    setVisible(false);
  };

  const onClear = () => {
    form.setFieldsValue({ AssetId: undefined, AssetTitle: undefined });
    form.resetFields(["AssetId", "AssetTitle"]);
  };

  return (
    <>
      <Form.Item name="AssetId" noStyle required>
        <input type="hidden" />
      </Form.Item>
      <Form.Item name="AssetTitle" noStyle required>
        <input type="hidden" />
      </Form.Item>
      <Form.Item label={t("MEDIA_LABEL", "Media")}>
        <Form.Item
          noStyle
          shouldUpdate={(prev, cur) =>
            prev.AssetId !== cur.AssetId || prev.AssetTitle !== cur.AssetTitle
          }
        >
          {() => {
            const id = form.getFieldValue("AssetId") as number | undefined;
            const title = form.getFieldValue("AssetTitle") as string | undefined;
            const hasPick =
              id != null && title != null && String(title).trim() !== "";
            const sourceValueView: React.ReactElement = hasPick ? (
              <span>
                <Link to={`${ROUTES.ASSET_DETAILS}/${id}`}>{title}</Link>
              </span>
            ) : (
              <span>{t("SELECT", "Select Media")}</span>
            );
            return (
              <Row gutter={16}>
                <Col style={{ display: "flex", alignItems: "center" }}>
                  {sourceValueView}
                  <SelectAssetsModal
                    visible={visible}
                    onClose={() => {
                      setVisible(false);
                    }}
                    onSelect={onSelect}
                  />
                </Col>
                <Col>
                  {hasPick ? (
                    <Button
                      icon={<Icon type="delete" />}
                      onClick={onClear}
                      style={{ marginRight: "8px" }}
                    />
                  ) : null}
                  <Button
                    icon={<Icon type="edit" />}
                    onClick={() => {
                      setVisible(true);
                    }}
                  />
                </Col>
              </Row>
            );
          }}
        </Form.Item>
      </Form.Item>
    </>
  );
}

export default ActionTypeMedia;
